// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__30xWV","info":"PatientInfo_info__31XyC"};